import React, { useState, useEffect } from 'react';
import './ContactModal.css';
import { FORMSPREE_ENDPOINT } from '../../config/formspree';

const ContactModal = ({ isOpen, onClose, title = 'Get in Touch', subject = 'Enquiry — Sendcheap' }) => {
  const [form, setForm] = useState({ name: '', email: '', company: '', message: '' });
  const [status, setStatus] = useState('idle');
  const [submittedEmail, setSubmittedEmail] = useState('');

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    if (isOpen) document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [isOpen, onClose]);

  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);

  if (!isOpen) return null;

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('submitting');
    try {
      const res = await fetch(FORMSPREE_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ ...form, _subject: subject }),
      });
      const data = await res.json();
      if (data.ok) {
        setSubmittedEmail(form.email);
        setStatus('success');
        setForm({ name: '', email: '', company: '', message: '' });
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <div className="cm-overlay" onClick={onClose}>
      <div className="cm-panel" onClick={(e) => e.stopPropagation()}>
        <button className="cm-close" onClick={onClose} aria-label="Close">✕</button>

        {status === 'success' ? (
          <div className="cm-success">
            <div className="cm-success-icon">✓</div>
            <h3>Message received!</h3>
            <p>We'll get back to you at <strong>{submittedEmail}</strong> within 24 hours.</p>
            <button className="cm-btn" onClick={onClose}>Close</button>
          </div>
        ) : (
          <>
            <h2 className="cm-title">{title}</h2>
            <p className="cm-desc">Fill in the form and our team will get back to you within 24 hours.</p>
            <form className="cm-form" onSubmit={handleSubmit}>
              <div className="cm-row">
                <div className="cm-field">
                  <label>Full Name</label>
                  <input name="name" type="text" placeholder="John Doe" value={form.name} onChange={handleChange} required />
                </div>
                <div className="cm-field">
                  <label>Business Email</label>
                  <input name="email" type="email" placeholder="you@company.com" value={form.email} onChange={handleChange} required />
                </div>
              </div>
              <div className="cm-field">
                <label>Company / Business Name <span className="cm-optional">(optional)</span></label>
                <input name="company" type="text" placeholder="Acme Ltd" value={form.company} onChange={handleChange} />
              </div>
              <div className="cm-field">
                <label>Message</label>
                <textarea name="message" rows="4" placeholder="Tell us what you need..." value={form.message} onChange={handleChange} required />
              </div>
              {status === 'error' && (
                <p className="cm-error">Something went wrong. Please try again.</p>
              )}
              <button className="cm-btn" type="submit" disabled={status === 'submitting'}>
                {status === 'submitting' ? 'Sending…' : 'Send Message →'}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default ContactModal;
